jQuery.fn.extend({

  dropdownOpen: function() {
    return this.each(function() {
      $(this).next().slideDown(100);
      $(this).toggleClass('option-dropdown-open')

    });
  },

  dropdownClose: function() {
      $( ".option-dropdown-open" ).next().slideUp(100);
      $( ".option-dropdown-open" ).removeClass('option-dropdown-open');
  },

  dropdownSelect: function(e) {
    return this.each(function() {
      $(this).find('.option-wrapper label').removeClass('option-active')
      var radiobtn = $(this).parent().find('input[type=radio]');
      var selectedOptionLabel = $(this).parents('.option-wrapper').find('.selected-option-value');
      var defaultLabel = selectedOptionLabel.find('.default-label');
      var selectedLabel = selectedOptionLabel.find('.selected-label');

      if($(radiobtn).is(':checked') && !$(this).hasClass('option_required')){
        e.preventDefault();
        radiobtn.prop('checked', false);
        $(this).removeClass('option-active');
        defaultLabel.removeClass('hidden-label');
        selectedLabel.addClass('hidden-label');
        if($(radiobtn).hasClass('frame_addon')){
          $('#main-photo-frame').remove();
          $('#real-life-frame').remove();
          $('[data-first-slide]').removeClass('frame__added');
        }else if($(radiobtn).hasClass('legend_addon')){
          var legendContainer = $(radiobtn).parents('.option-wrapper');
          legendContainer.find('.enavi_error_message').hide();
          legendContainer.find('.option-container').removeClass('enavi_option_error');
          legendContainer.find('input').removeClass('enavi_option_error');
        }
      }else{
        $(this).addClass('option-active');
      
        if($(this).find('.checkmark').length){
          var postfix = ' added';
        }else{
          var postfix = '';
        }
        defaultLabel.addClass('hidden-label');
        selectedLabel.html('<span>'+$(this).attr('data-option')+postfix+'</span>' + '<span style="margin-left:30px;">' + 
        $(this).attr('data-price') +'</span>');
        selectedLabel.removeClass('hidden-label');
      }
      if (!$(this).hasClass('multi-options')){
        $(this).dropdownClose();
      }
        
    });
  }
});

$(document).ready(function () {
  $('.option-toggle-wrapper').click(function () {
    if($(this).hasClass('disabled')){
      return;
    }
    if ( $(this).next().is( ":hidden" ) ) {
      $(this).dropdownClose();
      $(this).dropdownOpen();
    } else {
      $(this).dropdownClose();
    }
  })

  $('.option-wrapper .variant__button-label').click(function (e) {
    $(this).dropdownSelect(e);   
  })

  $(document).mouseup(function(e) 
  {
      var container = $('.option-container');
      var datepickerui = $('.ui-datepicker');
      // if the target of the click isn't the container nor a descendant of the container
      if (!container.is(e.target) && container.has(e.target).length === 0 && (!datepickerui.is(e.target) && datepickerui.has(e.target).length === 0)) 
      {
        $(this).dropdownClose();
      }
  });

  //Personalization options dropdown
  if($( ".datepicker" ).length){
    $( ".datepicker" ).datepicker({
      showOn: "both",
      buttonImage: "//wendygold.com/cdn/shop/t/187/assets/ico-option-date.svg?v=172003736464609751591782263355",
      buttonImageOnly: true,
      buttonText: "Select date",
      changeMonth: true,
      changeYear: true,
      yearRange: "-122:+10"
    });
    $( ".date-format" ).on( "change", function() {
      $(this).parent().prev().find('.datepicker').datepicker( "option", "dateFormat", $( this ).val() );
    });
  }

  $('.personalize-option').on( "change", function () {
    var selectedOptionLabel = $(this).parents('.option-wrapper').find('.selected-option-value');
    var defaultLabel = selectedOptionLabel.find('.default-label');
    var selectedLabel = selectedOptionLabel.find('.selected-label');
    var emptyItems = 0;
    $('.personalize-option').each(function(){
      if($(this).is('input[type="text"]')){
        if (!$(this).val() || !$(this).val().trim()){
          emptyItems = emptyItems + 1;
        }
      }
    });
   
    if(emptyItems == 0){
      defaultLabel.addClass('hidden-label');
      selectedLabel.removeClass('hidden-label');
    }else{
      defaultLabel.removeClass('hidden-label');
      selectedLabel.addClass('hidden-label');
    }
  })

})